export enum GetStartedEvent {
  TaskListLoadFailed = "Task List Load Failed",
  HelpResourceClicked = "Help Resource Clicked",
  BookDemoClicked = "Book Demo Clicked",
  BookDemoFailed = "Book Demo Failed",
  BookDemoClosed = "Book Demo Closed",
  TaskListToggled = "Task List Toggled",
  TaskStatusUpdated = "Task Status Updated",
  TaskLinkClicked = "Task Link Clicked",
  TaskDescriptionHovered = "Task Description Hovered",
  InsuranceMessageClicked = "Insurance Message Clicked",
}
